import type { JSX } from "react";
import React, { useState, useEffect, useRef } from "react";
import { Link } from "react-router-dom";
import cn from "classnames";

import { Menu, Tab, Display } from "./styles";
import { IProps } from "./interfaces";

const Tabs = ({
    active: initialActive,
    pathname,
    children,
    autoPlay,
    autoPlayTime,
    onChange,
    linkPrefix = "",
    lg,
    expand,
    center,
    $titleMinWidth,
    noBorderBottom,
    dark,
}: IProps) => {
    const [active, setActive] = useState(initialActive || 0);
    const [height, setHeight] = useState<string | number>("auto");
    const [opacity, setOpacity] = useState(1);
    const [transition, setTransition] = useState("");
    const timer = useRef<ReturnType<typeof setTimeout> | null>(null);
    const timer2 = useRef<ReturnType<typeof setInterval> | null>(null);
    const elementRef = useRef<HTMLDivElement | null>(null);

    const goNext = () => {
        setActive(oldActive => {
            let newActive = oldActive + 1;
            if (newActive === children.length) {
                newActive = 0;
            }
            setOpacity(0);
            setTransition("0s");
            setTimeout(repos, 100);
            if (onChange) {
                onChange(newActive);
            }
            return newActive;

        })
        if (autoPlay) {
            timer.current = setTimeout(goNext, autoPlayTime);
        }
    };

    const repos = () => {
        if (!elementRef.current) return;
        let height = elementRef.current.getBoundingClientRect().height;
        setHeight(height);
        setOpacity(1)
        setTransition("");
    };

    useEffect(() => {
        if (pathname) {
            setActive(children.findIndex(el => el.link === pathname))
        }
        if (autoPlay) {
            timer.current = setTimeout(goNext, autoPlayTime);
        }
        timer2.current = setInterval(repos, 1000);
        return () => {
            clearTimeout(timer.current!);
            clearInterval(timer2.current!);
        }
    }, [pathname]);

    return (
        <div
            style={{
                textAlign: center ? "center" : undefined,
            }}
        >
            <Menu className={cn({ Expand: expand }, "TabMenu")} noBorderBottom={!!noBorderBottom}>
                {children.map((tab, index) => {
                    return (
                        <Tab
                            as={tab.link ? Link : "div"}
                            {...(tab.link && {
                                to: linkPrefix + (tab.link ? tab.link : "")
                            })}
                            key={index}
                            $titleMinWidth={$titleMinWidth}
                            className={cn({ Active: index === active, Lg: !!lg, Expand: !!expand, Dark: !!dark })}
                            onClick={() => {
                                clearTimeout(timer.current!);
                                setActive(index);
                                setOpacity(0);
                                setTransition("0s");
                                setTimeout(repos, 100);
                                if (onChange) {
                                    onChange(index);
                                }
                            }}
                        >
                            {tab.title}
                        </Tab>
                    );
                })}
            </Menu>
            <Display style={{ height, opacity, transition }}>
                <div ref={elementRef}>
                    {children[active] &&
                        (typeof children[active].content === "function"
                            ? (children[active].content as () => JSX.Element)()
                            : children[active].content)}
                </div>
            </Display>
        </div>
    );
}

export default Tabs;
